var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Heading, Text } from 'wix-style-react';
export var InfoLine = function (_a) {
    var children = _a.children, _b = _a.clearPadding, clearPadding = _b === void 0 ? false : _b, dataHook = _a.dataHook, _c = _a.heading, heading = _c === void 0 ? false : _c, maxLines = _a.maxLines, _d = _a.subtext, subtext = _d === void 0 ? false : _d, weight = _a.weight, rest = __rest(_a, ["children", "clearPadding", "dataHook", "heading", "maxLines", "subtext", "weight"]);
    if (!children) {
        return null;
    }
    var renderText = function () {
        return heading ? (React.createElement(Heading, { size: "medium", maxLines: maxLines, dataHook: dataHook + '.heading' }, children)) : (React.createElement(Text, { size: subtext ? 'tiny' : 'small', weight: weight, maxLines: maxLines, dataHook: dataHook + '.text' }, children));
    };
    if (clearPadding && !Object.keys(rest).length) {
        return renderText();
    }
    return (React.createElement(Box, __assign({ paddingTop: clearPadding ? 0 : '4px', dataHook: dataHook }, rest), renderText()));
};
//# sourceMappingURL=InfoLine.js.map